import { columnGrid } from "../../../../../utils/lunchGrid/ColumnGrid";
import { dataMinuta } from "../../minutaDTO";
import { exportTableToExcel, fotmatDateHeader, getLStorage, setLStorage, setSStorage } from '../../../../../../global.d'
import * as Yup from 'yup';
import { error, success, warn } from "../../../../../utils/customToasd";
import { getUserByToken } from "app/helpers/getUserByToken";
import moment from 'moment'
import { callSP, getFlaskRunMinuta } from "setup/axios/AxiosCallSP";
import { ColDef } from "ag-grid-community";
import { ColGroupDef } from "@ag-grid-community/all-modules";
import { CacheSitesUserService } from "app/modules/auth/components/services/cache-ceco-user/cache-ceco-user.service";
import { IRecipeBySites } from "app/modules/auth/components/interfaces/recipe-by-site";

const columnHide = [{ value: 'ponderado', text: '% ponderado' }, { text: '$ plato', value: 'cto_plato' }, { text: '$ Plato Pond.', value: 'ctoPlatoPonderado' }];
const defautStyle: React.CSSProperties = { display: 'none' }
export let intervaloMinuta: any = false;

export let version = '2'
export const parseNnumber = (data: any) => {
    if (typeof (data) === 'string') {
        const p = parseFloat(data.replace(",", "."));
        return p
    } else {
        return data
    }
}
const addColum = (dataColum: columnGrid[], key: number) => {
    columnHide.forEach((item, key2) => {
        dataColum.push(
            {
                text: item.text,
                value: key2.toString(),
                classNameColum: 'sub-title',
                key: item.value + key,
                style: defautStyle,
                id: key
            }
        )
    })
}

const unirFilas = (arrayEstructura: any, minutaBase: dataMinuta) => {
    let arrayFilas: any[] = [];
    if (arrayEstructura.length > 0) {
        arrayEstructura.forEach((item: any, key: number) => {
            item.forEach((item3: any, key3: number) => {
                Object.keys(item3).forEach((item2: any) => {
                    let keyFecha: number | undefined = undefined;
                    minutaBase.header.forEach((item: any, key) => {
                        if (item.fecha) {
                            if (item.fecha === item3.fecha)
                                keyFecha = key
                        } else {
                            if (item === item3.fecha)
                                keyFecha = key + 1;
                        }
                    });
                    if (keyFecha !== undefined) {
                        if (item2 === "cabecera") {
                            if (arrayFilas[(item3.key)] === undefined) {
                                arrayFilas[(item3.key)] = {};
                            }
                            arrayFilas[(item3.key)][item2] = item3["cabecera"];
                        }
                        else if (item2 !== "nombreEstructura" && item2 !== "nombreEstructuraPadre" && item2 !== "estructura_padre" && item2 !== "colorGrupoEstructura") {
                            if (arrayFilas[(item3.key)] === undefined) {
                                arrayFilas[(item3.key)] = {};
                            }
                            arrayFilas[(item3.key)][item2 + keyFecha] = item3[item2];
                        } else {
                            if (arrayFilas[(item3.key)] === undefined) {
                                arrayFilas[(item3.key)] = {};
                            }
                            arrayFilas[(item3.key)][item2] = item3["nombreEstructura"];
                            arrayFilas[(item3.key)]["nombreEstructuraPadre"] = item3["nombreEstructuraPadre"];
                            arrayFilas[(item3.key)]["estructura_padre"] = item3["estructura_padre"];
                            arrayFilas[(item3.key)]["colorGrupoEstructura"] = item3["colorGrupoEstructura"] || "";
                        }
                    }
                })
                if (arrayFilas[(item3.key)] === undefined) {
                    arrayFilas[(item3.key)] = {}
                }
            })
        })
    }
    return arrayFilas;
}

const armarColum = (minutaBase: dataMinuta) => {
    let dataColum: columnGrid[] = [
        {
            text: 'Estructura servicios',
            value: '0',
            key: 'nombreEstructura',
            width: '100',
            showModal: true,
            id: 1,
            classNameColum: 'estructura-label',
            classNameRow: 'clase-row-1',
        }
    ]
    minutaBase.header.forEach((item: any, key: number) => {
        const hideColumn = columnHide.map(item2 => {
            return item2.value + key
        })
        dataColum.push(
            {
                text: item.fecha,
                value: key.toString(),
                key: "receta" + key,
                showModalItem: true,
                id: key,
                classNameColum: 'clase-2',
                classNameRow: 'clase-row-2',
                hideColumn: hideColumn,
                dataFecha: item.data,
                show: false,
                eventShow: (item: columnGrid) => { },
            }
        )
        addColum(dataColum, key);
    });
    return dataColum;
}
export const armarColumGrid = (minutaBase: dataMinuta) => {
    let dataColum: columnGrid[] = [
        {
            text: 'Estructura Padre',
            value: '0',
            key: 'nombreEstructura',
            width: '100',
            showModal: true,
            id: 1,
            classNameColum: 'estructura-label',
            classNameRow: 'clase-row-1',
        },
        {
            text: 'Estructura servicios',
            value: '0',
            key: 'nombreEstructura',
            width: '100',
            showModal: true,
            id: 1,
            classNameColum: 'estructura-label',
            classNameRow: 'clase-row-1',
        }
    ]
    minutaBase.header.forEach((item: any, key: number) => {
        const hideColumn = columnHide.map(item2 => {
            return item2.value + key
        })
        dataColum.push(
            {
                text: item.fecha,
                value: key.toString(),
                key: "receta" + key,
                showModalItem: true,
                id: key,
                classNameColum: 'clase-2',
                classNameRow: 'clase-row-2',
                hideColumn: hideColumn,
                dataFecha: item.data,
                show: false,
                eventShow: (item: columnGrid) => { },
            }
        )
        addColum(dataColum, key);
    });
    return dataColum;
}
export const columnModalMinutaFood = () => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            field: 'place',
            headerName: 'Sitio',
            minWidth: 300,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'regime',
            headerName: 'Regimen',
            minWidth: 180,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'service',
            headerName: 'Servicio',
            minWidth: 180,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'structure',
            headerName: 'Estructura',
            minWidth: 180,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        }
    ]
    return dataColum
}
export const columnModalValidateConf = () => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            field: 'contrato',
            headerName: 'Contrato',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'id_minuta',
            headerName: 'Minuta',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'version',
            headerName: 'Version',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'tipo',
            headerName: 'Tipo',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'rol',
            headerName: 'Rol',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
    ]
    return dataColum
}

export const columnModalDetalle = () => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            field: 'periodo',
            headerName: 'Periodo',
            minWidth: 300,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'texto',
            headerName: 'Texto',
            minWidth: 300,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'estado',
            headerName: 'Estado',
            minWidth: 180,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
    ]
    return dataColum
}

export const columnModalValidate = () => {
    // {
    //     "tipo": "Frecuencia",
    //     "fecha": {},
    //     "id_estructura": 72,
    //     "id_ingrediente": 152,
    //     "id_contrato": 44,
    //     "id_minuta": 1,
    //     "estructura": "Postre 2",
    //     "Nombretipoingprincipal": "Postre Leche Tradicional"
    // }
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            field: 'estructura',
            headerName: 'Estructura',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'Nombretipoingprincipal',
            headerName: 'Ingrediente principal',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'tipo',
            headerName: 'Tipo',
            minWidth: 180,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'glosa',
            headerName: 'Glosa',
            minWidth: 350,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'fecha',
            headerName: 'Fecha',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            valueFormatter: (params: any) => params.value ? moment(params.value.substring(0, 10)).format('DD-MM-YYYY') : '',
        },
    ]
    return dataColum
}

export const columnModalApprove = (aprobacion: boolean = false) => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        // {
        //     field: 'id_receta',
        //     headerName: 'Id',
        //     minWidth: 150,
        //     suppressMenu: true,
        //     filter: true,
        //     floatingFilter: true,
        // },
        // {
        //     field: 'receta',
        //     headerName: 'Receta',
        //     minWidth: 300,
        //     suppressMenu: true,
        //     filter: true,
        //     floatingFilter: true,
        // },
        {
            field: 'tipo',
            headerName: 'Tipo',
            minWidth: 300,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'glosa',
            headerName: 'Glosa',
            minWidth: 400,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        // {
        //     field: 'comentario',
        //     headerName: 'Comentario',
        //     suppressMenu: true,
        //     minWidth: 300,
        //     editable: true,
        // },
    ]

    if (aprobacion) {
        dataColum.push({
            field: 'aprobacion',
            headerName: 'Estado',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            valueFormatter: (params: any) => params.value == 1 ? 'Aprobado' : 'Rechazado',
        })
    } else {
        dataColum.push({
            field: 'aprobar',
            headerName: 'Aprobar',
            minWidth: 150,
            suppressMenu: true,
            checkboxSelection: true,
            headerCheckboxSelection: true,
        })
    }

    return dataColum
}

const formatEstado = (params: any) => params.value == 1 ? 'Para este periodo ya existe minuta creada' : 'Sin minuta en este periodo'
export const columnModalHomologate = (homologate: boolean = false) => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            field: 'id',
            headerName: 'Contrato',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'ceco',
            headerName: 'Id Sitio',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'cli_nombre',
            headerName: 'Sitio',
            minWidth: 250,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'reg_codigo',
            headerName: 'Id Régimen',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'regimen',
            headerName: 'Régimen',
            minWidth: 250,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'codServicio',
            headerName: 'Id Servicio',
            minWidth: 120,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'servicio',
            headerName: 'Servicio',
            minWidth: 250,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'estado',
            headerName: 'Estado',
            minWidth: 350,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            valueFormatter: formatEstado,
        },
    ]

    if (homologate) {
        dataColum.unshift({
            field: 'homologar',
            headerName: 'Homologar',
            minWidth: 150,
            suppressMenu: true,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            cellRendererParams: {
                checkbox: true,
            },
        })
    }

    return dataColum
}

export const showColumRow = (item2: any,
    dataColum: columnGrid[], changeGrid: any, setChangeGrid: any, setDataColumn: any, color: boolean) => {
    item2.show = !item2.show
    dataColum?.forEach((item) => {
        if (item.hideColumn && item2.key != item.key) item.show = false
    })
    let cont: any = []
    let data2: any = dataColum?.filter((item) => item.hideColumn)
    data2?.map((item: any) => {
        cont = [...cont, ...item.hideColumn]
    })
    if (cont.length > 0) {
        const dc = dataColum?.map((item) => {
            if (cont.includes(item.key)) {
                if (item2.hideColumn.includes(item.key)) {
                    if (!item2.show) {
                        item.style = { display: 'none' }
                        item.classNameColum = ''
                    } else {
                        item.style = { display: '' }
                        item.classNameColum = 'expanded-colum'
                        item.classNameRow = 'expanded-row'
                    }
                } else {
                    item.style = { display: 'none' }
                    item.classNameColum = ''
                }
            } else {
                item.style = { display: '' }
                item.classNameColum = ''
            }
            return item;
        })
        changeGrid = !changeGrid;
        setChangeGrid(changeGrid);
        setDataColumn(dc);
    }
}
const armarRow = (minutaBase: dataMinuta) => {
    let arrayEstructura: any = [];
    minutaBase.columRow.forEach((item, key) => {
        minutaBase.dataRow.forEach((item2) => {
            if (item2?.idEstructura.toString() === item?.id.toString()) {
                if (arrayEstructura[item2.idEstructura.toString()] === undefined) {
                    arrayEstructura[item2.idEstructura.toString()] = []
                }
                item2.key = key;
                item2.colorGrupoEstructura = item.colorGrupoEstructura;
                item2.porcentajeGrupo = item.porcentajeGrupo;
                item2.cabecera = item2.head ? true : false;
                arrayEstructura[item2.idEstructura.toString()].push(item2);
            }
        });
    });
    return unirFilas(arrayEstructura, minutaBase)
}
const nextRow = async (dataColumnInitial: columnGrid[], dataColumn: columnGrid[], setDataColumn: any, nxt: any) => {
    const arrayColum = dataColumnInitial.slice(1, dataColumnInitial.length)
    arrayColum.forEach((item, key) => (item.numRow = key))
    let lastPosition: number | undefined = undefined
    arrayColum.forEach((item) => {
        if (item.key === dataColumn[dataColumn.length - 1].key) {
            lastPosition = item.numRow
        }
    })
    if (arrayColum.length - 1 === lastPosition) {
        nxt.setLoad(false);
        return
    }
    let nextPage: number = nxt.nextDate + 1;
    const page: number = nextPage * 4;
    if (lastPosition && nextPage) {
        const p: number = lastPosition + 5;
        let dataInitColum: columnGrid[] = arrayColum.slice(page, p);
        if (dataInitColum.length < 28 && p < 48) {
            dataInitColum = arrayColum.slice(page, p);
        }
        if (arrayColum[lastPosition + page] !== undefined) {
            nxt.setNextDate(nextPage);
        } else if (arrayColum[lastPosition + 4] !== undefined) {
            nxt.setNextDate(nextPage);
        }
        dataInitColum.unshift(dataColumnInitial[0])
        if (nxt.expandirMinuta) {
            setLStorage("openFechas", "[]")
            dataInitColum?.forEach((item, key) => {
                if (item.hideColumn === undefined && key > 0) {
                    item.style = { display: '' }
                    item.classNameColum = 'expanded-colum dfghdfgery'
                    item.classNameRow = 'expanded-row asdqwe'
                    item.show = false
                    item.eventShow = undefined
                }
            })
        } else {
            let fecha = await getLStorage("openFechas")
            if (fecha != undefined) {
                fecha = JSON.parse(fecha)
            } else {
                fecha = []
            }
            dataInitColum?.forEach((item, key) => {
                if (item.hideColumn === undefined && key > 0) {
                    if (item.id === fecha[0]) {
                        item.style = { display: '' }
                        item.classNameColum = 'expanded-colum'
                        item.classNameRow = 'expanded-row'
                        item.show = false
                        item.eventShow = undefined
                    } else {
                        item.style = { display: 'none' }
                        item.classNameColum = ''
                        item.classNameRow = ''
                        item.show = false
                        item.eventShow = undefined
                    }
                }
            })
        }
        setDataColumn(dataInitColum)
    }
    setTimeout(() => {
        const table: any = document.getElementById("container-table");
        table.scrollLeft = 10000
        nxt.setLoad(false);
    }, 600);
}

const backRow = async (dataColumnInitial: columnGrid[], dataColumn: columnGrid[], setDataColumn: any, nxt: any) => {
    const arrayColum = dataColumnInitial.slice(1, dataColumnInitial.length)
    arrayColum.forEach((item, key) => (item.numRow = key))
    let lastPosition: number | undefined = undefined;
    arrayColum.forEach((item) => {
        if (item.key === dataColumn[dataColumn.length - 1].key) {
            lastPosition = item.numRow
        }
    })
    let nextPage: number = nxt.nextDate - 1;
    let page: number = nxt.nextDate * 4;
    if (nextPage >= 0 && lastPosition) {
        const p: number = lastPosition - 3;
        if (page > 0) {
            page = page - 4;
            if (page < 0) {
                page = 0
            }
        }
        let dataInitColum: columnGrid[] = []
        dataInitColum = arrayColum.slice(p - 28, p);
        if (dataInitColum.length === 0) {
            nxt.setNextDate(0);
            nxt.setLoad(false);
            return
        } else if (dataInitColum.length < 28 && p < 48) {
            dataInitColum = arrayColum.slice(page, p);
        }
        if (nxt.nextDate > -1) {
            nxt.setNextDate(nextPage);
        }
        dataInitColum.unshift(dataColumnInitial[0])
        if (nxt.expandirMinuta) {
            setLStorage("openFechas", "[]")
            dataInitColum?.forEach((item, key) => {
                if (item.hideColumn === undefined && key > 0) {
                    item.style = { display: '' }
                    item.classNameColum = 'expanded-colum'
                    item.classNameRow = 'expanded-row'
                    item.show = false
                    item.eventShow = undefined
                }
            })
        } else {
            let fecha = await getLStorage("openFechas")
            if (fecha != undefined) {
                fecha = JSON.parse(fecha)
            } else {
                fecha = []
            }
            dataInitColum?.forEach((item, key) => {
                if (item.hideColumn === undefined && key > 0) {
                    if (item.id === fecha[0]) {
                        item.style = { display: '' }
                        item.classNameColum = 'expanded-colum'
                        item.classNameRow = 'expanded-row'
                        item.show = false
                        item.eventShow = undefined
                    } else {
                        item.style = { display: 'none' }
                        item.classNameColum = ''
                        item.classNameRow = ''
                        item.show = false
                        item.eventShow = undefined
                    }
                }
            })
        }
        setDataColumn(dataInitColum)
    }
    setTimeout(() => {
        const table: any = document.getElementById("container-table");
        table.scrollLeft = -10000
        nxt.setLoad(false);
    }, 600);
}

const nextRowWeek2 = async (dataColumnInitial: columnGrid[], dataColumn: columnGrid[], setDataColumn: any, nxt: any, dias: any) => {
    const arrayColum = dataColumnInitial.slice(1, dataColumnInitial.length)
    arrayColum.forEach((item, key) => (item.numRow = key))
    let lastPosition: number | undefined = undefined
    arrayColum.forEach((item) => {
        if (item.key === dataColumn[dataColumn.length - 1].key) {
            lastPosition = item.numRow! + 1
        }
    })
    if (arrayColum.length - 1 === lastPosition) {
        nxt.setLoad(false);
        return
    }

    let dias_siguientes = dias * 4
    let hasta = (lastPosition! + dias_siguientes)
    let desde = 0
    if (dias == 1) {
        if (hasta >= 32) {
            desde = hasta - 28
        } else {
            desde = 4
        }
    }
    if (dias == 7) {
        desde = lastPosition!
    }
    if (dias == 30) { // para rodal hasta el final
        desde = arrayColum.length - 28
        hasta = arrayColum.length
    }

    // para evitar eror cuando le den nuevamente al boton de avanzar y no hayan mas datos
    if (desde >= arrayColum.length) { 
        desde = arrayColum.length - 28
        hasta = arrayColum.length
    }
    let dataInitColum: columnGrid[] = arrayColum.slice(desde, hasta);

    dataInitColum.unshift(dataColumnInitial[0])
    if (nxt.expandirMinuta) {
        setLStorage("openFechas", "[]")
        dataInitColum?.forEach((item, key) => {
            if (item.hideColumn === undefined && key > 0) {
                item.style = { display: '' }
                item.classNameColum = 'expanded-colum dfghdfgery'
                item.classNameRow = 'expanded-row asdqwe'
                item.show = false
                item.eventShow = undefined
            }
        })
    } else {
        let fecha = await getLStorage("openFechas")
        if (fecha != undefined) {
            fecha = JSON.parse(fecha)
        } else {
            fecha = []
        }
        dataInitColum?.forEach((item, key) => {
            if (item.hideColumn === undefined && key > 0) {
                if (item.id === fecha[0]) {
                    item.style = { display: '' }
                    item.classNameColum = 'expanded-colum'
                    item.classNameRow = 'expanded-row'
                    item.show = false
                    item.eventShow = undefined
                } else {
                    item.style = { display: 'none' }
                    item.classNameColum = ''
                    item.classNameRow = ''
                    item.show = false
                    item.eventShow = undefined
                }
            }
        })
    }
    setDataColumn(dataInitColum)
    setTimeout(() => {
        const table: any = document.getElementById("container-table");
        table.scrollLeft = 10000
        nxt.setLoad(false);
    }, 600);

}

const backRowWeek2 = async (dataColumnInitial: columnGrid[], dataColumn: columnGrid[], setDataColumn: any, nxt: any, dias: any) => {
    const arrayColum = dataColumnInitial.slice(1, dataColumnInitial.length)
    arrayColum.forEach((item, key) => (item.numRow = key))
    let lastPosition: number | undefined = undefined
    arrayColum.forEach((item) => {
        if (item.key === dataColumn[dataColumn.length - 1].key) {
            lastPosition = item.numRow! + 1
        }
    })

    let dias_anteriores = 0
    let desde = 0

    dias_anteriores = dias * 4

    let hasta = (lastPosition! - dias_anteriores)

    desde = hasta - 28
    if (desde < 0) {
        desde = 0
        hasta = 28
    }

    if (dias == 0) {
        desde = 0
        hasta = 28
    }
    let dataInitColum: columnGrid[] = arrayColum.slice(desde, hasta);

    dataInitColum.unshift(dataColumnInitial[0])
    if (nxt.expandirMinuta) {
        setLStorage("openFechas", "[]")
        dataInitColum?.forEach((item, key) => {
            if (item.hideColumn === undefined && key > 0) {
                item.style = { display: '' }
                item.classNameColum = 'expanded-colum dfghdfgery'
                item.classNameRow = 'expanded-row asdqwe'
                item.show = false
                item.eventShow = undefined
            }
        })
    } else {
        let fecha = await getLStorage("openFechas")
        if (fecha != undefined) {
            fecha = JSON.parse(fecha)
        } else {
            fecha = []
        }
        dataInitColum?.forEach((item, key) => {
            if (item.hideColumn === undefined && key > 0) {
                if (item.id === fecha[0]) {
                    item.style = { display: '' }
                    item.classNameColum = 'expanded-colum'
                    item.classNameRow = 'expanded-row'
                    item.show = false
                    item.eventShow = undefined
                } else {
                    item.style = { display: 'none' }
                    item.classNameColum = ''
                    item.classNameRow = ''
                    item.show = false
                    item.eventShow = undefined
                }
            }
        })
    }
    setDataColumn(dataInitColum)
    setTimeout(() => {
        const table: any = document.getElementById("container-table");
        table.scrollLeft = 10000
        nxt.setLoad(false);
    }, 600);

}

const getDataColum = async (idContrato: string, accessToken: any, versionMinuta: any, idMinuta: string, idMinutaLong: string) => {
    const user: any = await getUserByToken(accessToken);
    // let version = "2"
    if (user.role.toString() == 8 || user.role.toString() == 12) {
        version = "3"
    }
    if (user.role.toString() == 9 || user.role.toString() == 10) {
        version = "4"
    }
    if (user.role.toString() == 13) {
        version = '2'
    }

    const dataEstructuraMasivo: any = await callSP('amd_getGrupoEstructuraMasivo', [])
    setSStorage('dataEstructuraMasivo', dataEstructuraMasivo.data.result)


    const dataColumRow: any = await callSP('amd_getEstructuraByContratoByMinuta', [
        { text: 'contrato', value: idContrato },
        { text: 'id_minuta', value: idMinutaLong }
    ])

    setLStorage('estructuras', dataColumRow.data.result)

    // TODO revisar datos que retorna amd_getCabeceraMinutaByContrato, no filtra por id_minuta
    const dataHeader: any = await callSP('amd_getCabeceraMinutaByContrato', [
        { text: 'contrato', value: idContrato },
        { text: 'version', value: versionMinuta },
        { text: 'id_minuta', value: idMinuta },
    ])
    const dataRow: any = await callSP('amd_getMinutaByContrato', [
        { text: 'contrato', value: idContrato },
        { text: 'version', value: versionMinuta },
        { text: 'id_minuta', value: idMinuta },
    ])
    const date = dataHeader.data.result.map((item: any) => {
        return {
            fecha: fotmatDateHeader(item.fecha),
            data: item
        }
    })
    dataRow.data.result.forEach((item: any) => {
        Object.keys(item).forEach((value: any) => {
            if (JSON.stringify(item[value]) === "{}") {
                item[value] = ""
            }
        })
        item.fecha = fotmatDateHeader(item.fecha)
    })
    const dataMinuta: dataMinuta = {
        header: date,
        columRow: dataColumRow.data.result,
        dataRow: dataRow.data.result,
    }
    return dataMinuta
}

export const getDataColun = (filter: any) => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            headerName: "Seleccionar",
            cellRenderer: (params: any) => {
                return <i style={{ cursor: "pointer" }} onClick={() => { return filter(params) }} className="bi bi-check-circle"></i>
            }
        },
        {
            field: 'rec_codigo',
            headerName: 'Código',
            minWidth: 150,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'rec_nombre',
            headerName: 'Nombre',
            minWidth: 205,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'Nombretipoingprincipal',
            headerName: 'Ingrediente Principal',
            minWidth: 205,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'IngredienteSecundario',
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            headerName: 'Ingrediente Secundario',
            minWidth: 175
        },
        {
            field: 'precio',
            headerName: 'Precio',
            minWidth: 100
        },
        {
            field: 'NombreCosto',
            headerName: 'Costo',
            minWidth: 160,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        // {
        //     field: 'Idtipoingprincipal',
        //     headerName: 'Metodo Cocción',
        //     minWidth: 205,
        //     suppressMenu: true,
        //     filter: true,
        //     floatingFilter: true,
        // },
        {
            field: 'NombreCategorizacionCompleja',
            headerName: 'Complejidad',
            minWidth: 160,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
    ]
    return dataColum;
}

export const getDataColunMinutaVertical = (filter: any) => {
    const dataColum: (ColDef | ColGroupDef)[] = [
        {
            headerName: "Seleccionar",
            maxWidth: 150,
            cellRenderer: (params: any) => {
                return <i style={{ cursor: "pointer" }} onClick={() => { return filter(params) }} className="bi bi-check-circle"></i>
            },
        },
        {
            field: 'macroIngrediente',
            headerName: 'Macro Ingrediente',
            minWidth: 205,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'id_ingrediente_principal',
            headerName: 'Id Ingrediente principal',
            minWidth: 205,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'Nombretipoingprincipal',
            headerName: 'Ingrediente Principal',
            minWidth: 205,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'Color',
            headerName: 'Nombre Color',
            minWidth: 175,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
    ]
    return dataColum;
}
export const getDataRold = async (idContrato: string, idMinuta: string, setLoadProduct: any, showAlert: boolean = true) => {
    const dataSP: any = await callSP('amd_getRecetasByContrato', [
        { text: 'contrato', value: idContrato },
        { text: 'id_minuta', value: idMinuta },
    ])
    setLoadProduct(true)
    const cacheSitesUserService = new CacheSitesUserService()
    if (!cacheSitesUserService.loadGetService)
        success("Recetas cargadas exitosamente!")
    return dataSP.data.result;
}
export const getDataR = async (ceco: string, setLoadProduct: any, showAlert: boolean = true) => {
    const cacheService = new CacheSitesUserService();
    let dataResp: IRecipeBySites[] = await cacheService.getRecipeBySites(ceco);
    setLoadProduct(true)
    const cacheSitesUserService = new CacheSitesUserService()
    if (!cacheSitesUserService.loadGetService)
        success("Recetas cargadas exitosamente!")
    return dataResp;
}
export const validateSchemaModalMinutaFood = () => {
    return Yup.object().shape({
        place: Yup.array().validateArray(),
        regime: Yup.array().validateArray(),
        service: Yup.array().validateArray(),
    });
}
export const regenerateTemplateMinutaFood = () => {
    return Yup.object().shape({
        Macro_Estructura: Yup.array().validateArray(),
        Estructura: Yup.array().validateArray()
    });
}
export const inputModalMinutaFood = (sitios: any, getServices: any, servicios: any, regimens: any, setLoad: any, addColumn: any, row?: any, alertModal?: any, setAlertModal?: any, idContrato?: any, idMinuta?: any, estructuras: any[] = []): any => {
    return {
        title: "Replicar Minuta",
        message: "",
        rows: row,
        colum: columnModalMinutaFood(),
        showSave: true,
        showAddButton: true,
        modalFullscreen: true,
        close: () => {
            setAlertModal(undefined)
        },
        initialValues: {
            place: [{ text: "", value: "" }],
            regime: [{ text: "", value: "" }],
            service: [{ text: "", value: "" }],
            structure: [],
        },
        arrayInput: [
            {
                columInput: 3,
                campo: 'place',
                label: 'Sitio',
                type: 'autocomplete',
                campoChk: true,
                advanceOptions: {
                    id: 'place',
                    placeholder: 'Ingrese sitio',
                    multiple: false,
                    options: sitios,
                },
                className: 'form-control b-0 p-0 form-control-lg input-contract input-modal-minuta',
                onChange: async function (event: any, setFieldValue: any, values: any) {
                    if (values.place.length > 0) {
                        setLoad(true);
                        getServices(values.place[0].value, setFieldValue, values, this)
                    } else {
                    }
                },
            },
            {
                columInput: 3,
                campo: 'service',
                label: 'Servicio',
                type: 'autocomplete',
                advanceOptions: {
                    id: 'service',
                    multiple: false,
                    placeholder: 'Ingrese servicio',
                    options: servicios,
                },
                onChange: async (event: any, setFieldValue: any, values: any) => {
                    setTimeout(() => {
                        setFieldValue("service", values.service)
                    }, 500);
                },
                className: 'form-control b-0 p-0 form-control-lg input-contract input-modal-minuta',
            },
            {
                columInput: 3,
                campo: 'regime',
                label: 'Regimen',
                type: 'autocomplete',
                advanceOptions: {
                    id: 'regime',
                    placeholder: 'Ingrese régimen',
                    multiple: false,
                    options: regimens
                },
                onChange: async (event: any, setFieldValue: any, values: any) => {
                    setTimeout(() => {
                        setFieldValue("regime", values.regime)
                    }, 500);
                },
                className: 'form-control b-0 p-0 form-control-lg input-contract input-modal-minuta',
            },
            {
                columInput: 3,
                campo: 'structure',
                label: 'Estructura',
                type: 'autocomplete',
                advanceOptions: {
                    id: 'structure',
                    placeholder: 'Ingrese estructura',
                    multiple: true,
                    options: estructuras,
                },
                onChange: async (event: any, setFieldValue: any, values: any) => {
                    setTimeout(() => {
                        setFieldValue("structure", values.structure)
                    }, 500);
                },
                className: 'form-control b-0 p-0 form-control-lg input-contract input-modal-minuta',
            },
        ],
        save: (value: any, setFieldValue: any, formikProps: any) => {
            // setLoad(true)
            const arrEst: any[] = row.filter((e: any) => e.structure !== '')
            const arr: any[] = row.filter((e: any) => e.structure == '')
            try {
                arr?.forEach(async (r: any) => {
                    const resp3 = await callSP('amd_replicarMinuta', [
                        { text: "contrato", value: idContrato.toString() },
                        { text: "sitio", value: r.idPlace.toString() },
                        { text: "regimen", value: r.idRegime.toString() },
                        { text: "servicio", value: r.idService.toString() },
                        { text: "id_minuta", value: idMinuta.toString() },
                    ])
                    if (resp3?.status == 200) {


                        if (resp3?.data.result.length) {

                            if (resp3?.data.result[0].hasOwnProperty('response')) error(resp3?.data.result[0].response)
                            else {
                                setAlertModal(inputModalValidate(resp3?.data.result))
                            }
                        } else success("Ingresado exitosamente")
                    } else {
                        error("Error al crear el servicio " + r.service.toString())
                    }
                })

                arrEst?.forEach(async (r: any) => {
                    const resp3 = await callSP('amd_replicarMinutaEstructuras', [
                        { text: "contrato", value: idContrato.toString() },
                        { text: "sitio", value: r.idPlace.toString() },
                        { text: "regimen", value: r.idRegime.toString() },
                        { text: "servicio", value: r.idService.toString() },
                        { text: "id_minuta", value: idMinuta.toString() },
                        { text: "id_estructura ", value: r.idStructure.toString() },
                    ])
                    if (resp3?.status == 200) {


                        if (resp3?.data.result.length) {

                            if (resp3?.data.result[0].hasOwnProperty('response')) error(resp3?.data.result[0].response)
                            else {
                                setAlertModal(inputModalValidate(resp3?.data.result))
                            }
                        } else success("Ingresado exitosamente")
                    } else {
                        error("Error al crear el servicio " + r.service.toString())
                    }
                })
                setAlertModal(undefined)
                setLoad(false)
            } catch (error) {

                setLoad(false)
            }
        }
    }
}

export const inputModalValidate = (row?: any): any => {
    return {
        title: "Detalle Validación",
        message: "",
        rows: row,
        colum: columnModalValidate(),
        showSave: true,
        modalFullscreen: true,
        arrayInput: []
    }
}

export const validateRegenerateTemplates = async (formikProps: any, idContrato: any, idMinuta: any, setAlertModal: any, setLoad: any, setDataDetalle?: any) => {
    const respon = await formikProps.validateForm();
    if (Object.keys(respon).length > 0) {
        Object.keys(respon).forEach((value: any) => {
            warn(`Debe ingresar ${value.replace("_", " ")}`)
        })
    } else {
        const { Macro_Estructura, Estructura } = formikProps.values;
        const marcoEstructura = Macro_Estructura.map((item: any) => { return item.value });
        const estructuras = Estructura.map((item: any) => { return item.value });
        runMinuta(idContrato, idMinuta, setAlertModal, marcoEstructura.toString(), estructuras.toString(), setLoad, setDataDetalle);
    }
}
export const runMinuta = async (idContrato: any, idMinuta: any, setInfoModal: any, marcoEstructura: any, estructura: any, setLoad: any, setDataDetalle?: any) => {
    try {
        setLoad(true);
        const { data } = await getFlaskRunMinuta({
            idContrato: idContrato,
            idMinuta: idMinuta,
            macro: marcoEstructura,
            estructura: estructura
        })

        const { data: dataIdJob }: any = await callSP('amd_getLogbyId', [
            {
                text: 'id',
                value: data.idJob,
            },
        ])
        success("Minuta creada exitosamente");
        setDataDetalle(dataIdJob.result)
        // setInfoModal(undefined)
        setLoad(false);
    } catch (err) {
        error("Error al crear la minuta", 'bottom-center');
        setInfoModal(undefined)
        setLoad(false);
        Promise.reject(err);
    }
}

export const setParametersByArray = (arr: any) => {
    return {
        parameters: arr,
    }
}

export const editUserMinuta = async (id_minuta: string, id_user: string, setEditMinutaUser: any, data: any) => {
    if (window.location.href.includes("minutaFood")) {
        const dataResp: any = await callSP('amd_minuta_bloquead_usuario', [
            { text: 'id_minuta', value: id_minuta },
            { text: 'id_usuario', value: id_user }
        ])
        if (!dataResp.data.result[0].edita && data.seeMessageUser) {
            warn("El usuario " + dataResp.data.result[0].usuario + " Esta editando la minuta")
            setEditMinutaUser("El usuario " + dataResp.data.result[0].usuario + " Esta editando la minuta")
            data.setSeeMessageUser(false);
        } else {
            setEditMinutaUser("")
        }
    } else {
        clearInterval(intervaloMinuta);
    }
}

export const intervalStart = (id_minuta: string, id_user: string, setEditMinutaUser: any, data: any) => {
    if (!intervaloMinuta) {
        intervaloMinuta = setInterval(() => { editUserMinuta(id_minuta, id_user, setEditMinutaUser, data) }, 90000);
    }
}

export const exportsMinutas = async (dataResult: any, setLoad: any, selectedRows: any) => {
    //regimen, ceco, nombreCeco, ser_nombre, fechaMinuta
    let dataRB = await getLStorage("dataRowB")
    dataRB = JSON.parse(dataRB);
    let table = "";
    let idTable = 0
    dataResult?.forEach((column: any, key: number) => {
        if (idTable !== 0) {
            idTable++
        }
        table += `<table id="MinutaVertical${idTable}">
                <thead>
                    <tr>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Minuta ${selectedRows[key].fechaMinuta.split("T")[0]}</th>
                    </tr>
                    <tr>
                        <th>${selectedRows[key].ceco} - ${selectedRows[key].nombreCeco}</th>
                    </tr>
                    <tr>
                        <th>${selectedRows[key].ser_nombre} - ${selectedRows[key].regimen}</th>
                    </tr>
                    <tr>
                        <th></th>
                    </tr>
                </thead>
            </table>`;
        idTable++
        table += `<table border="1" className='table tabla-menu-lateral-2 table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 table-minuta' id="MinutaVertical${idTable}">
            <thead>`;
        {
            table += `<tr>`
            column.map((colum: any) => {
                table += `<th>${colum.text}</th>`
            })
            table += ` </tr>`;
        }
        table += `</thead>
            <tbody>`;
        {
            dataRB[key].map((row: any, key2: number) => {
                if (row == null) return;
                table += `<tr>`;
                {
                    column.map((colum: any) => {
                        try {
                            const dataRow = row[colum.key] ? row[colum.key] : ""
                            if (colum.key !== "nombreEstructura") {
                                table += `<td style="background-color:${row["color" + colum.id]}">${dataRow}</td>`;
                            } else {
                                table += `<td>${dataRow}</td>`;
                            }
                        } catch (error) {
                            console.log(error);

                        }
                    })
                    table += `</tr>`;
                }
            })
        }
        table += `</tbody ></table >`;
    })
    const data: any = document.getElementById("global-table-minuta")
    data.innerHTML = table;
    exportTableToExcel("", "MinutaVertical", (dataResult.length + dataResult.length))
    setLoad(false);

}
export { armarColum, armarRow, getDataColum, backRow, nextRow, nextRowWeek2, backRowWeek2 }